import { dateModify } from 'kickstart-ui/lib/dates';
import { formatDate, formatTime } from 'kickstart-ui/src/helpers/dates.js';

export function dateTime(date, time = date, date_format = 'm/d/Y', time_format = 'h:ia') {
    return date
        ? `${formatDate(date, date_format, 'Y-m-d')} ${formatTime(time, time_format)}`
        : null;
}

/**
 * Get the current local date in YYYY-MM-DD format
 * @param {string} timezone e.g. America/New_York
 * @returns {string}
 */
export function currentLocalDate(timezone) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: timezone }).format(new Date);
}

/**
 * @param value
 * @returns {boolean}
 */
function hasDateBound(value) {
    return !['', null, undefined].includes(value);
}

/**
 *
 * @param value
 * @returns {string}
 */
export function formatDateWithin(value) {
    let [from, to] = value.split(',');

    if ( hasDateBound(to) && hasDateBound(from) ) {
        return `between ${to} and ${from} days ago`;
    }

    if ( hasDateBound(to) ) {
        return `up to ${to} days ago`;
    }

    return `from ${from} days ago`;
}

/**
 *
 * @param value
 * @returns {string}
 */
export function formatDateUpcoming(value) {
    const upcoming = String(value).split(',');
    let [from, to] = upcoming.length === 1
        ? [null, upcoming[0]]
        : upcoming;

    if ( hasDateBound(from) && hasDateBound(to) ) {
        return `between ${from} and ${to} days from now`;
    }

    if ( hasDateBound(to) ) {
        return `up to ${to} days from now`;
    }

    return `from ${from} days from now`;
}

/**
 *
 * @param {string} value
 * @returns {string}
 */
export function formatDatePeriod(value) {
    const [modifier, interval] = value.split('_');

    const display_modifier = {
        previous: 'Last',
        current: 'This',
        next: 'Next',
    }[modifier];

    return `${display_modifier} ${interval}`;
}

/**
 *
 * @param {Date} date
 * @param {'Y'|'M'|'W'|'D'} interval
 * @param {number} value
 * @returns {Date}
 */
export function incrementDate(date, interval = 'D', value = 1) {
    const increment = {
        'Y': 'year',
        'M': 'month',
        'W': 'week',
        'D': 'day',
    }[interval] ?? 'day';

    return dateModify(date, increment, value);
}

/**
 * Get the minimum of two dates.
 *
 * @param {Date|string|null} date1
 * @param {Date|string|null} date2
 * @returns {Date|string|null}
 */
export function minDate(date1, date2) {
    if ( !date1 && !date2 ) {
        return null;
    }

    if ( !date1 ) {
        return date2;
    }

    if ( !date2 ) {
        return date1;
    }

    return new Date(date1) < new Date(date2) ? date1 : date2;
}
